import { OlCommission } from '../../../lib/types/models/ol/commission/ol-commission'
import { OlCommissionInput } from '../../../lib/types/models/ol/commission/ol-commission-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createOlCommission = async (data: OlCommissionInput) => {
  return restApiClient
    .url(constructApiUrl(API.ols.createOlCommission.url, null))
    .post<OlCommission, OlCommissionInput>(data)
}
